/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BookSummaryViewModel } from './BookSummaryViewModel';
import {
    BookSummaryViewModelFromJSON,
    BookSummaryViewModelFromJSONTyped,
    BookSummaryViewModelToJSON,
} from './BookSummaryViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfBookSummaryViewModel
 */
export interface ResultOfBookSummaryViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfBookSummaryViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfBookSummaryViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfBookSummaryViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfBookSummaryViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfBookSummaryViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfBookSummaryViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfBookSummaryViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {BookSummaryViewModel}
     * @memberof ResultOfBookSummaryViewModel
     */
    data?: BookSummaryViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfBookSummaryViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfBookSummaryViewModel interface.
 */
export function instanceOfResultOfBookSummaryViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfBookSummaryViewModelFromJSON(json: any): ResultOfBookSummaryViewModel {
    return ResultOfBookSummaryViewModelFromJSONTyped(json, false);
}

export function ResultOfBookSummaryViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfBookSummaryViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : BookSummaryViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfBookSummaryViewModelToJSON(value?: ResultOfBookSummaryViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': BookSummaryViewModelToJSON(value.data),
        'Count': value.count,
    };
}

